import { CreateTechnicianDTO } from "./dto";
import { BusinessTechnicianServiceImpl } from "./serviceImpl";


export interface BusinessTechnicianService {
    CreateTechnicianCreation(data: CreateTechnicianDTO): Promise<string>
    GetBusinessTechnician(): Promise<any>
    EditBusinessTechnician(id: string, data: CreateTechnicianDTO): Promise<any>
    GetBusinessTechnicianById(id: string): Promise<any>
    removeBusinessTechnician: (id: string) => Promise<void>
}

export function NewBusinessTechnicianService(): BusinessTechnicianService {
    return new BusinessTechnicianServiceImpl();
}
